import React, { useState, useEffect } from "react";
import { Header } from 'react-frontier2';
import { PAGE_PUBLIC } from "../../AdminConfig";
import { useParams } from "react-router-dom";
import { EventData } from "../../AdminClasses";
import { SidebarContainer } from "../../components";
import { useTitle } from "@arema/components/Hooks";
import { useUser } from "../../AdminHooks";
import API from "../../API";
import slugify from "slugify";

import EventDetails from './EventDetails';
import EventOptions from './EventOptions';
import EventDateList from './EventDateList';
import EventDate from './EventDate';
import EventDateCreate from './EventDateCreate';
import EventBalance from "./EventBalance";
import EventFormList from "./EventFormList";
import EventDateFormList from "./EventDateFormList";
import EventDateCreateQuestions from "./EventDateCreateQuestions";
import EventPromotions from "./EventPromotions";
import EventCoupon from "./EventCoupon";
import EventReports from "./EventReports";
import EventDateSeats from "./EventDateSeats";
import EventOrders from "./EventOrders";
import EventCodeList from "./EventCodeList";
import EventCodeDetails from "./EventCodeDetails";

var EventContainer = ()=>{
	// var navigate = useNavigate();
	// var location = useLocation();
	// var [section, setSection] = useState<string>(params['*']);
	var params = useParams<{ id: string, '*': string }>();
	var [eventError, setEventError] = useState<string>(null);
	var [event, setEvent] = useState<EventData>(null);
	var { setTitle } = useTitle();
	var { user, hasAccess } = useUser();

	useEffect(()=>{
		if(!event){
			API.getEvent(parseInt(params.id), true).then(res=>{
				if(res.error) return setEventError(res.message);
				setEvent({ 
					...res.data,
					commission_return: res.data.commission_return ? res.data.commission_return*100 : null,
				});
				setTitle(res.data.event_name)
			}).catch(err=>{
				return setEventError('Hubo un error inesperado cargando los datos del evento (LCL-1)');
			});
		}
	}, [])

	if(eventError){
		return <Header text="Error" subtext={eventError} iconName='face-frown-open' />
	}else if(!event){
		return <Header loading text="Cargando evento" />
	}
	
	var onEditEvent = (ev: EventData)=>{
		setEvent(ev);
	}

	var route_params = {
		event: event,
		onEditEvent: onEditEvent,
		// handleRender: handleRoute,
		// render: navigateContainer,
	}

	return <SidebarContainer 
		header={'Editar evento'}
		routes={[
			{ url: `/events/:eventid`,												component: EventDetails, },
			{ url: `/events/:eventid/dates`, 									component: EventDateList },
			{ url: `/events/:eventid/dates/create`,							component: EventDateCreate },
			{ url: `/events/:eventid/dates/:id`, 								component: EventDate },
			{ url: `/events/:eventid/balance`,									component: EventBalance },
			{ url: `/events/:eventid/options`,									component: EventOptions },
			{ url: `/events/:eventid/promotions`,								component: EventPromotions },
			{ url: `/events/:eventid/promotions/coupon/:coupon_id`,		component: EventCoupon },
			{ url: `/events/:eventid/forms`,										component: EventFormList  },
			{ url: `/events/:eventid/forms/:date_id`,							component: EventDateFormList },
			{ url: `/events/:eventid/forms/:date_id/q/:question_id`,		component: EventDateCreateQuestions },
			{ url: `/events/:eventid/reports`,									component: EventReports  },
			{ url: `/events/:eventid/reports/:date/seats`,					component: EventDateSeats  },
			{ url: `/events/:eventid/orders`,									component: EventOrders  },
			{ url: `/events/:eventid/codes`,										component: EventCodeList  },
			{ url: `/events/:eventid/codes/:code`,								component: EventCodeDetails  },
		]}
		routeParams={route_params}
		getTitle={(r, ix)=>{
			return event.event_name;
		}}
		items={[
			{ text: 'Detalles', 				icon: 'edit', 							url: `/events/${params.id}` },
			{ text: 'Calendarios', 			icon: 'calendar', 					url: `/events/${params.id}/dates` },
			{ text: 'Ordenes',	 			icon: 'ticket',	 					url: `/events/${params.id}/orders` },
			{ text: 'Estado de cuenta', 	icon: 'file-invoice-dollar', 		url: `/events/${params.id}/balance` },
			{ text: 'Opciones', 				icon: 'cog', 							url: `/events/${params.id}/options` },
			{ text: 'Códigos',			 	icon: 'key', 							url: `/events/${params.id}/codes` },
			{ text: 'Promociones',		 	icon: 'star', 							url: `/events/${params.id}/promotions` },
			{ text: 'Formularios',			icon: 'question-circle',			url: `/events/${params.id}/forms` },
			{ text: 'Reportes',				icon: 'clipboard',					url: `/events/${params.id}/reports` },
			{ text: 'Ver evento',			icon: 'eye',							url: `${PAGE_PUBLIC}/e/${params.id}-${slugify(event?.event_name.toLowerCase())}`, target: '_blank', selectable: false }
		]}
		contentHeader={(
			<Header text={event.event_name} subtext={event.published ? 'Publicado' : 'No publicado'} style={{ marginTop: 0, paddingTop: 0 }} />
		)}
	/>
}

export default EventContainer;